import logo from "Assets/logo.png";

const SimpleNavbar = () => {
    return (
        <div className="bg-brand-charcoal px-5 w-full h-auto py-10 text-white text-center flex flex-col gap-10 items-center justify-center">
            <div className="flex flex-col md:flex-row gap-3 text-center items-center justify-center ">
                <img src={logo} alt="Salesmrkt Logo" />
                <p>© {new Date().getFullYear()}, Salesmrkt. All Rights Reserved.</p>
            </div>
            <p>
                This website is not a part of the Facebook website or Facebook Inc.<br />
                Additionally, this website is NOT endorsed by Facebook in any way. Facebook is a trademark of Facebook, Inc.
            </p>
        </div>
    );
}

export default SimpleNavbar;